import React from "react";
import {GroupEvents} from "../../calendar/group-events";

export default function EntityEventsTab({group,group_id}) {

    return <GroupEvents last_updated={group.google_calendar_updated_at} calendar_id={group?.['power_ups']?.['google_calendar']?.['config']?.calendar_id}
                        group_id={group_id}/>;
};